<template>
  <div v-cloak class="Resource">
    <!-- 头部banner图 -->
    <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">关于星辰</div>
        <div class="texts">赋能财商教育，助力财务自由，引领财富增长</div>
      </div>
    </div>

    <!-- 中间内容 -->
    <div class="containers">
      <Bread :list="breadList" class="ma-b-30" />
      <div class="flex">
        <img src="../img/about1.png" class="ma-r-30" />
        <div>
          <span class="fon-24 weight500"> 关于星辰</span>
          <div class="fon-18 line-height33 ma-t-40">
            随着国民财富持续增长、投资理财渠道不断拓宽和“421”家庭结构带来经济压力等因素的驱动，国民理财需求逐步被唤醒，数智方舟应运而生。
            致力于帮助用户正确理解财富、增强风险意识、提高财商认知，做出专业、科学，合理的投资理财决策。为资本市场及经济社会的健康稳定有序发展贡献一份力量。
            <div class="ma-t-20">
              数智方舟拥有在金融领域内具备丰富投资理财教学经验的优秀师资力量，精心打磨研发围绕收入、消费、信贷、投资、理财、资产配置、风险防范为核心的精品课程，通过直播，
              视频，音频，图文等方式多维度为用户教学，用通俗易懂的方式把晦涩难懂的财经知识教授给用户，提升用户认识财富，创造财富，管理财富的能力。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex f-between width1220">
      <img src="../img/about2.png" />
      <img src="../img/about3.png" />
    </div>
    <div>
      <div class="person">
        <div class="t-center flex f-center flex-direction fon-24 font-bold">
          <div class="fon-24 c-fff ma-t-50">专业讲师团队</div>
          <div class="b-009297 ma-t-10"></div>
        </div>

        <div class="width1200 flex f-between">
          <swiper
            style="background: none"
            :slides-per-view="3"
            :space-between="50"
            :options="swiperOption"
            ref="mySwiper"
          >
            <swiper-slide
              style="background: none"
              v-for="(item, index) in teacher"
              :key="index"
            >
              <div
                v-for="(items, indexs) in item"
                :key="indexs"
                class="pa-lr-30"
              >
                <div class="position">
                  <img :src="items.Picture" class="img_228" />
                  <div class="absolute">
                    <div class="pa-lr-20 text-justify">
                      {{ items.Content }}
                    </div>
                  </div>
                </div>
                <div class="c-fff flex flex-direction t-center ma-t-15">
                  <span class="fon-16">{{ items.Name }}</span>
                  <span class="c-b8 ma-t-10">{{ items.Title }}</span>
                </div>
              </div>
            </swiper-slide>

            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            <div
              class="swiper-button-next"
              slot="button-next"
              @click="swiperNext"
            ></div>
            <div
              class="swiper-button-prev"
              slot="button-prev"
              @click="swiperPrev"
            ></div>
          </swiper>

          <!-- <div v-for="(item, index) in lecurerList" :key="index">
            <div class="position">
              <img :src="item.Picture" class="img_228" />
              <div class="absolute">
                <div class="pa-lr-20 text-justify">
                  {{ item.Content }}
                </div>
              </div>
            </div>
            <div class="c-fff flex flex-direction t-center ma-t-15">
              <span class="fon-16">{{ item.Name }}</span>
              <span class="c-b8 ma-t-10">{{ item.Title }}</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="ma-t-30 pa-b-40">
        <div class="t-center flex f-center flex-direction fon-24 font-bold">
          <div class="fon-24 c-fff ma-t-50 c-000">为什么选择数智方舟？</div>
          <div class="ma-t-10"></div>
        </div>
        <div class="flex f-center f-jcenter ma-tb-80">
          <img src="../img/about5.png" />
          <img src="../img/about6.png" />
          <img src="../img/about7.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss"  scoped>
html,
body {
  position: relative;
  height: 100%;
}
body {
  background: #eee;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;
  padding: 0;
}
.swiper-button-prev {
  color: #234775;
}
.swiper-button-next {
  color: #234775;
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}
.img_228 {
  width: 228px;
  height: 305px;
}
body {
  background: #fff;
}
.end {
  height: 500px;
}
.ma-tb-80 {
  margin: 80px 0;
}
.c-b8 {
  color: #b8b8b8;
}
.width1200 {
  width: 1200px;

  margin: 90px auto;
}
.width1220 {
  width: 1220px;
  margin: 40px auto;
}
.ma-t-50 {
  margin-top: 50px;
}
.rz {
  width: 50%;
  margin: 15px auto;
  border-radius: 3px;
  text-align: center;
  padding: 10px 10px;
  background-color: #e6e6e6;
  color: #000;
  font-weight: 500;
}
.containers {
  width: 1200px;

  margin: 30px auto;
  background: #ffffff;
  padding: 0px 14px 25px 14px;
  box-sizing: border-box;

  .fy {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product-main {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .product-list {
      width: 370px;
      height: 121px;
      margin-right: 20px;
      margin-bottom: 38px;
      display: flex;
      justify-content: flex-start;
      .p-image {
        width: 35%;
        height: 121px;
        margin-right: 9px;
        .p-imgs {
          width: 121px;
          height: 121px;
          border-radius: 10px;
        }
      }
      .p-title {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 8px;
      }
      .p-detail {
        // width:100%;
        font-size: 14px;
        height: 38px;
        line-height: 19px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .p-right {
        width: 65%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .download {
        width: 90px;
        height: 30px;
        background: rgba(15, 117, 189, 1);
        border-radius: 20px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        text-decoration: none;
      }
    }
  }
}
.Resource {
  background: #fff;
}
.Resource .swiper {
  width: 100%;
  height: 314px;
  background-image: url(../img/about_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  .toptexts {
    width: 736px;
    position: absolute;
    top: 28%;
    margin: 0 auto;
    left: 50%;
    margin-left: -368px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;

    color: #fff;
    opacity: 0.75;
    text-align: center;
    .texts {
      line-height: 30px;
      letter-spacing: 3px;
      font-size: 16px;
    }
    .imgtitle {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}
.fy {
  margin-top: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Resource .container {
  width: 100%;
  // height: 600px;
  // min-height: 500px;
  background: #ffffff;
  box-sizing: border-box;
  padding: 30px 40px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.Resource .container {
  .el-tabs__header {
    display: flex;
    justify-content: center;
  }
  .el-tabs__content {
    min-width: 1080px;
    margin: 0 auto;
  }
  .el-tabs__item {
    padding: 0 60px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }
  .el-tabs__active-bar {
    height: 4px;
    font-weight: bold;
    background: rgba(15, 117, 189, 1);
  }
  .is-active {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: rgba(15, 117, 189, 1);
  }
  .el-tabs__content {
    margin-top: 45px;
  }
}
.Resource .student {
  width: 1100px;
  height: 106px;
  margin-bottom: 32px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;

  .img-left {
    width: 20%;
    height: 106px;

    .img-lefts {
      width: 187px;
      height: 106px;
    }
  }
  .text-right {
    width: 80%;
    .title {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #333333;
      margin-top: 3px;
      margin-bottom: 5px;
    }
    .text-detail {
      padding-right: 100px;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 18px;
      font-family: MicrosoftYaHei;
      color: rgba(102, 102, 102, 1);
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .icons {
      // width: 100%;
      margin-top: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .deletes {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          i {
            font-size: 18px;
          }
        }
      }

      .icons-left {
        width: 100%;
        padding-right: 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icons-left-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
      .delete-right {
        width: 40%;
        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
    }
  }
}
.box {
  // width: 1200px;
  height: 175px;
  margin-top: 20px;
  border-bottom: #eee 1px solid;
}
.ma-t-60 {
  margin-top: 60px !important;
}
.ma-t-10 {
  margin-top: 10px !important;
}
.btn_green {
  width: 220px;
  height: 40px;
  background: #234775;
  border-radius: 20px;
  color: #fff;
}
.btn_white {
  width: 220px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #234775;
  border-radius: 20px;
  color: #234775;
}
.img_230 {
  width: 230px;
  height: 149px;
}
.c-5 {
  color: #555555;
}
.height300 {
  height: 80px;
}
.width419 {
  width: 419px;
}
.person {
  width: 100%;
  min-height: 630px;
  background: url(../img/about4.png);
  background-size: 100% 100%;
}
.position {
  position: relative;
  width: 100%;
  height: 90%;
}
.position:hover .absolute {
  z-index: 1;
  opacity: 1;
  height: 100%;
}
.absolute {
  width: 100%;
  height: 90%;
  opacity: 0;
  transition: all 0.2s ease;
  position: absolute;
  bottom: 0;
  background: rgba(000, 000, 000, 0.8);
  font-size: 12px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-carousel__item:nth-child(2n) {
  background-color: #000d31;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #004b6c;
}
.ma-lr-auto {
  margin-left: auto;
  margin-right: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.b-009297 {
  width: 200px;
  height: 3px;
  background: #234775;
}
</style>
 <script src="../swiper.min.js"></script>
<script>
import {
  resourcekind,
  kinddetail,
  studycollect,
  getproduct,
  getLecturer,
} from "../api.js";
import Bread from "../components/Bread.vue";
// Import Swiper Vue.js components

// studycollect
export default {
  name: "About",
  components: {
    Bread,
  },
  data() {
    return {
      activeName: "",
      kinds: [
        { Name: "进行中", Id: "0" },
        { Name: "往期回顾", Id: "1" },
      ],
      kindcontainer: [],
      kindlength: "",
      currentPage: 1, //当前页数
      tabid: "", //种类id
      totals: 0, //一个分类下的总条数
      saves: [],
      homeid: "", //首页传递的种类id
      pageshow: true,
      indexs: 0, //种类下标
      collects: true, //第一次点收藏
      sh: true,
      productlist: [],
      se: "",
      IsApprove: "", //是否认证
      tokens: "",
      play: false,

      breadList: [
        {
          name: "关于星辰",
          path: "/About",
        },
      ],
      //讲师信息
      lecurerList: [],

      swiperOption: {
        watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航。
        grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状。
        effect: "slide", //切换效果：默认为“位移切换”。
        loop: true, //让Swiper看起来是循环的。
        // autoplay: {
        //   //启动自动切换，具体选项如下：
        //   delay: 3000, //自动切换的时间间隔，单位ms
        //   stopOnLastSlide: false, //如果设置为true，当切换到最后一个slide时停止自动切换。（loop模式下无效）。
        //   disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。默认为true：停止。
        // },
        // 如果需要分页器，类名要和 HTML 中的相对应
        // pagination: {
        //   el: ".swiper-pagination", //自动隐藏
        //   clickable: true,
        // },
        //如果需要前进后退按钮，类名要和 HTML 中的相对应

        navigation: {
          nextEl: ".swiper-button-next", //自动隐藏
          prevEl: ".swiper-button-prev", //自动隐藏
          hiddenClass: "btn-hidden", //某些情况下需要隐藏前进后退按钮时，可以设定一个自定义的类名。
        },
      },

      teacher: [],
    };
  },

  created() {
    console.log("created----");
    this.loadDataLecturer();
    // this.getkind();
    // let homeid = this.$route.query.kid;
    // if (this.$route.params.labels) {

    // 	this.activeName = this.$route.params.labels;
    // 	console.log(this.$route.params.labels);
    // 	this.products();
    // }
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);
    // 判断是否从详情页面回来
    if (from.path == "/Study-detail") {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },

  // 其他页面进来时更新初始数据
  activated() {
    console.log("909090------");
    if (!this.$route.meta.isBack) {
      console.log("uiuiuiuu");
      let token = localStorage.getItem("AccessToken") || "";
      this.tokens = token;
      if (this.$route.params.labels) {
        this.activeName = this.$route.params.labels;
        this.products();
      }
      //   this.getkind();

      let homeid = this.$route.query.kid;

      if (homeid) {
        this.currentPage = 1;
        this.totals = 0;
        this.pageshow = true;
        this.indexs = 0;
        this.collects = true;
        this.sh = true;
        (this.kinds = []), (this.kindcontainer = []);
        this.saves = [];
        this.productlist = [];
        this.activeName = homeid;
        this.homeid = homeid;
      } else {
        console.log("ppppp===");
        this.homeid = "";

        // this.activeName = this.$route.query.labels;
      }
    }
    this.$route.meta.isBack = false;
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    // this.swiper.slideTo(1, 1000, false)
  },

  methods: {
    swiperNext() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
    swiperPrev() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    plays() {
      this.play = true;
    },
    toDetail(id = 1) {
      this.$router.push({
        path: "/Learn-detail",
        query: { id: id },
      });
    },

    //点击切换种类
    handleClick(tab) {
      console.log(tab);
      this.activeName = this.kinds[tab.index].Id;
      this.kinds;
    },

    upload(e) {
      window.open(e, "_blank");
    },

    // 设置保存页码
    save() {
      let kinds = this.kinds;
      this.saves = kinds.map((item) => {
        return { id: item.Id, page: 1 };
      });
    },

    // 学习资源种类列表
    getkind() {
      console.log("执行啦getkind");
      if (this.$route.params.labels) {
        if (this.$refs.cp) {
          this.$refs.cp.style.display = "none";
        }
      }
      let that = this;
      let token = localStorage.getItem("AccessToken") || "";
      let datas = {
        token: token,
        source: "pc",
        name: "",
        language: 1,
      };
      resourcekind(datas).then((res) => {
        if (res.data.Code == 0) {
          that.kinds = res.data.Data.data;
          let id = res.data.Data.data[0].Id;
          let kindlength = res.data.Data.data.length;

          this.kindlength = kindlength;
          if (this.homeid) {
            this.activeName = this.homeid;
            this.getdetail(this.homeid, 1);
          } else {
            if (this.$route.params.labels) {
              this.$refs.cp.style.display = "none";
              this.products();
              this.activeName = this.$route.params.labels;
            } else {
              this.activeName = id;
              this.getdetail(id, 1);
            }
          }

          this.save();
        }
        // else {
        // 	that.$message.error(res.data.Message);
        // }
      });
    },

    // 分类内容
    getdetail(id, page) {
      console.log("执行啦getdetail===");
      let that = this;
      that.se = 1;
      let token = localStorage.getItem("AccessToken") || "";
      let datas = {
        token: token,
        source: "pc",
        name: "",
        categoryId: id,
        language: 1,
        pageIndex: page,
        pageSize: 8,
      };
      kinddetail(datas).then((res) => {
        if (res.data.Code == 0) {
          that.IsApprove = res.data.Data.IsApprove;
          that.kindcontainer = res.data.Data.data;

          that.totals = res.data.Data.count;
        }
        // else {
        // 	that.$message.error(res.data.Message);
        // }
      });
    },

    //产品列表
    products() {
      let token = localStorage.getItem("AccessToken") || "";

      let datas = {
        token: token,
        source: "pc",
        name: "",
        language: 1,
      };
      getproduct(datas).then((res) => {
        if (res.data.Code == 0) {
          this.productlist = res.data.Data;
        }
        // else {
        // 	this.$message.error(res.data.Message);
        // }
      });
    },

    // 详情
    collect(id) {
      this.$router.push({
        path: "/Study-detail",
        query: { paths: "/Resource", name: "学习资源", id: id },
      });
    },

    // 收藏
    shou(id, index, status) {
      if (!status) {
        // 收藏

        let token = localStorage.getItem("AccessToken") || "";
        let datas = {
          token: token,
          source: "pc",
          id: id,
          language: 1,
        };
        studycollect(datas).then((res) => {
          if (res.data.Code == 0) {
            this.$set(this.kindcontainer[index], "IsCollection", true);
            this.$message({
              message: "收藏成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.Message,
              type: "success",
            });
          }
        });
      }
    },

    //获取讲师信息
    loadDataLecturer() {
      var _this = this;
      getLecturer().then((res) => {
        _this.lecurerList = res.data.Data;
        var swiperNum = Math.ceil(_this.lecurerList.length / 4) - 1;
        _this.teacher = [];
        for (var a = 0; a <= swiperNum; a++) {
          _this.teacher.push(_this.lecurerList.slice(a * 4, a * 4 + 4));
        }
        console.log(_this.teacher);
      });
    },

    // 当前页改变时触发
    handleCurrentChange(e) {
      let page = e; //点击的页码数
      let id = this.tabid; //当前种类id
      let index = this.indexs; //当前种类的下标
      this.getdetail(id, page);
      this.$set(this.saves[index], "page", page);
    },
    // 点击上一页
    prev(e) {
      let page = e; //点击的页码数
      let id = this.tabid; //当前种类id
      let index = this.indexs; //当前种类的下标
      this.getdetail(id, page);
      this.$set(this.saves[index], "page", page);
    },
    //点击下一页
    next(e) {
      let page = e; //点击的页码数
      let id = this.tabid; //当前种类id
      let index = this.indexs; //当前种类的下标
      this.getdetail(id, page);
      this.$set(this.saves[index], "page", page);
    },
  },
};
</script>
